<template>
    <div class="container">
      <div class="topView">
  <!--      <div class="rowFlex alignitems jus-btw">-->
  <!--        <van-search-->
  <!--            v-model="queryData.searchInfo"-->
  <!--            placeholder="请输入群名称"-->
  <!--            shape="round"-->
  <!--            background="#FFFFFF"-->
  <!--            class="searchView"-->
  <!--            @search="onSearch"-->
  <!--        >-->
  <!--          <template #left-icon style="display: flex;align-items: center;margin-right: 4px;">-->
  <!--            <img src="@/assets/image/statisticManage/search@3x.png" class="imgView48"/>-->
  <!--          </template>-->
  <!--        </van-search>-->
  <!--        <img v-if="filterItems && Object.keys(filterItems).length > 0" src="@/assets/image/statisticManage/filtered@3x.png" class="imgView48" @click="handleFilter"/>-->
  <!--        <img v-else src="@/assets/image/statisticManage/filter@3x.png" class="imgView48" @click="handleFilter"/>-->
  <!--      </div>-->
        <div class="rowFlex alignitems jus-btw p-tb-16">
          <div class="searchView" @click.stop="onSearch">
            <div class="searchContentView">
              <img src="@/assets/image/statisticManage/search@3x.png" class="imgView48" />
              <div class="searchInfoView one-text" :style="{color:searchInfoName ? '#3B3A38' : '#898887'}">{{searchInfoName ? searchInfoName : '请输入成员名称'}}</div>
            </div>
            <img v-if="!isNull(searchInfoName)" src="@/assets/image/statisticManage/clear@3x.png" class="imgView48" @click.stop="handleClear"/>
          </div>
          <img v-if="filterItems && Object.keys(filterItems).length > 0" src="@/assets/image/statisticManage/filtered@3x.png" class="imgView48" @click="handleFilter"/>
          <img v-else src="@/assets/image/statisticManage/filter@3x.png" class="imgView48" @click="handleFilter"/>
        </div>
        <!-- 统计数据 -->
        <div class="statisticView">
          <div class="rowFlex alignitems m-b-24">
            <div class="title">成员业务看板</div>
            <div
              class="timeItem"
              v-if="filterItems && filterItems.timeType"
            >
              {{filterItems.timeType.type == 'selectTime' ? customeTime : filterItems.timeType.value}}
            </div>
          </div>
          <div class="rowFlex alignitems">
            <div class="statisticItem" v-for="(item,index) in statisticItems" :key="index">
              <div class="columnFlex alignitems"
                   :style="{width: index < statisticItems.length - 1 ? 'calc(100% - 1px)' : '100%'}">
                <div class="titleView" :style="{color: item.color ? item.color : '#3B3A38'}">
                  {{ item.prefix ? item.prefix : '' }}{{ getTransformData(statisticInfo[item.prop], '-') }}
                </div>
                <div class="rowFlex alignitems">
                    <div class="infoView">{{ item.title }}</div>
                    <img src="@/assets/image/statisticManage/tip@3x.png" class="imgView24 m-l-4 shrin" @click.stop="handleTip(item)"/>
                </div>
              </div>
              <div class="line-1e1" v-if="index < statisticItems.length - 1"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="sectionTitle">成员列表（{{ total }}）</div>
      <div class="listView">
        <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
        >
          <van-list
              v-model="loading"
              :finished="finished"
              :error="error"
              finished-text="没有更多信息了～"
              error-text="数据加载失败，请重试"
              @load="onLoad"
          >
            <div class="listItem" v-for="(item,index) in list" :key="index" @click.stop="handleDetail(item)">
              <div class="itemTopView">
                <div class="rowFlex alignitems">
                  <img :src="!isNull(item.handPic) ? item.handPic : defaultHeadImg" class="imgView96 radius50"/>
                  <div class="itemTitleView m-l-24">{{ getTransformData(item.name) }}</div>
                </div>
                <div class="rightView">
                  <div class="btn">查看成员详情</div>
                  <img src="@/assets/image/statisticManage/next@3x.png" class="imgView24"/>
                </div>
              </div>
              <div class="rowFlex width100 m-t-48">
                <div class="columnFlex width50">
                  <div class="rowFlex alignitems m-b-12">
                    <div class="labelView">客户总数： </div>
                    <div class="nameView">{{ getTransformData(item.zrs) }}</div>
                  </div>
                  <div class="rowFlex alignitems m-b-12">
                    <div class="labelView">添加人数： </div>
                    <div class="nameView c554">{{ getTransformData(item.rqrs) }}</div>
                  </div>
                  <div class="rowFlex alignitems m-b-12">
                    <div class="labelView">流失人数： </div>
                    <div class="nameView c18a">{{ getTransformData(item.tqrs) }}</div>
                  </div>
                </div>
                <div v-if="!isNull(item.inclinationVal)" class="rowFlex jus-btw width50">
                  <div class="columnFlex">
                    <div class="labelView m-b-10">客户购买倾向：</div>
                    <div class="nameView m-b-10 two-text" style="max-width: 100px;">
                      {{ getTransformData(item.inclinationName) }}
                    </div>
                    <div v-if="item.inclinationVal" class="nameView c8ee">{{ Number(item.inclinationVal).toFixed(2) }}%</div>
                  </div>
                  <div class="chartView" v-if="item.inclinationVal && item.inclinationVal > 0">
                    <van-circle
                        v-model="item.inclinationVal"
                        :rate="item.inclinationVal"
                        layer-color="#E4E7ED"
                        stroke-linecap="square"
                        :stroke-width="150"
                        :size="63"
                    />
                  </div>
                </div>
                <div v-else class="rowFlex jus-btw width50">
                  <div class="rowFlex">
                    <div class="labelView m-b-10">客户购买倾向：</div>
                    <div class="labelView m-l-8">无</div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <filterDawer
        :show="showFilter"
        :corpId="corpId"
        :collapseItemList="collapseItemList"
        :activeNames="activeNames"
        :isBottom="false"
        @close="handleClose"
        @confirm="handleConfirm"
      ></filterDawer>
      <tipPopup
        :show="showTip"
        :title="currentTipItem.title"
        :content="currentTipItem.content"
        @close="handleTipClose"
      ></tipPopup>
    </div>
  </template>
  
  <script>
  import utils from "@/utils/common";
  import filterDawer from "../components/filterDawer.vue";
  import tipPopup from "../components/tipPopup.vue";
  import http from "@/utils/axios";
  import moment from "moment";
  export default ({
    components: {
      filterDawer,
      tipPopup
    },
    data() {
      return {
        defaultHeadImg:require('@/assets/image/statisticManage/defaultHead@3x.png'),
        currentUserId:'',
        corpId:'',
        showFilter: false,
        showTip:false,
        loading: false,
        finished: false,
        refreshing: false,
        error: false,
        currentTipItem:{},
        queryData: {
          searchInfo: '',
          startTime:`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`,
          endTime:`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`,
          timeType:0,
          orderType:0,
          orderVal:0
        },
        searchInfoName:'',
        selectItemIds:[],
        selectItems:[],
        filterItemIds:{
          timeType:0
        },
        filterItems:{
          timeType:{
            id: '0',
            title: '今日',
            type: 'dayTime',
            value: `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}-${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`
          }
        },
        customeTime:'',
        statisticItems: [
          {
            title: '总客户数',
            prop: 'allPeople',
            content:'筛选条件下，企微员工的外部联系人是微信用户数量总和。注.客户不去重'
          },
          {
            title: '新增人数',
            prop: 'newCustom',
            color: '#E15554',
            prefix: '+',
            content:'筛选条件下，企微员工新添加的客户数量。注.含主动与被动'
          },
          {
            title: '流失人数',
            prop: 'quitPeople',
            color: '#46C18A',
            prefix: '-',
            content:'筛选条件下，企微员工所流失的客户数量。注.含主动与被动'
          },
          {
            title: '净增人数',
            prop: 'joinPeople',
            color: '#E15554',
            prefix: '+',
            content:'筛选条件下，新增-流失。注.可为负数'
          }
        ],
        statisticInfo: {},
        list: [],
        page: 1,
        pageSize: 10,
        total: 0,
        activeNames: ['member'],
        collapseItemList: [
          {
            name: 'member',
            title: '客户信息',
            filterItems: [
              {
                title: '购买倾向',
                key: 'inclinationNames',
                isMultiple:true,
                list: [
                  {
                    id:'-1',
                    title:'全部'
                  },
                  ...utils.getLocalInclinationList()
                ]
              },
              {
                title: '排序依据',
                key: 'orderVal',
                isMultiple:false,
                list: [
                  {
                    id: '0',
                    title: '客户总数'
                  },
                  {
                    id: '1',
                    title: '添加人数'
                  },
                  {
                    id: '2',
                    title: '流失人数'
                  }
                ]
              },
              {
                title: '排序',
                key: 'orderType',
                isMultiple:false,
                list: [
                  {
                    id: '0',
                    title: '降序'
                  },
                  {
                    id: '1',
                    title: '升序'
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    created() {
      this.$loading.hide();
      let code = utils.getUrlParamByKey(window.location.href,'code')
      let corpId = utils.getUrlParamByKey(window.location.href,'corpId')
      let agentId = utils.getUrlParamByKey(window.location.href,'agentid')
      let agentType = utils.getUrlParamByKey(window.location.href,'agentType')
      localStorage.setItem('agentId',agentId)
      localStorage.setItem('agentType',agentType)
      localStorage.setItem('corpId',corpId)
      this.corpId = corpId
      utils.getUserIdByWXCode(this,code,corpId).then((res) => {
        this.currentUserId = res.wxUserId
      })
      // this.getInclinationList()
    },
    activated(){
      this.$loading.hide();
      if(!utils.isNullData(localStorage.getItem('selectItemIds'))){
        let selectItemIds = JSON.parse(localStorage.getItem('selectItemIds'))
        let selectItems = JSON.parse(localStorage.getItem('selectItems'))
        this.selectItemIds = selectItemIds
        this.selectItems = selectItems
        let names = selectItems.map((item) => {
          return item.name
        })
        this.queryData.searchInfo = selectItemIds.join(',')
        this.searchInfoName = names.join(',')
        localStorage.removeItem('selectItemIds')
        localStorage.removeItem('selectItems')
        this.onRefresh()
      }
    },
    mounted() {
      utils.remoteJs('https://res.wx.qq.com/open/js/jweixin-1.2.0.js')
      if(!utils.isNullData(localStorage.getItem('selectItemIds'))){
        let selectItemIds = JSON.parse(localStorage.getItem('selectItemIds'))
        let selectItems = JSON.parse(localStorage.getItem('selectItems'))
        this.selectItemIds = selectItemIds
        this.selectItems = selectItems
        let names = selectItems.map((item) => {
          return item.name
        })
        this.queryData.searchInfo = selectItemIds.join(',')
        this.searchInfoName = names.join(',')
        localStorage.removeItem('selectItemIds')
        localStorage.removeItem('selectItems')
      }
    },
    methods: {
      isNull(val){
        return utils.isNullData(val)
      },
      /**
       * 查询购买倾向列表
       */
      getInclinationList(){
        http({
          url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChat/findCategoryList",
          method: "post",
          parmes: {}
        }).then(rps => {
          if (rps.code == 200) {
            let data = rps.data;
            data.forEach((item) => {
              item.title = item.categoryName
            })
            let index = this.collapseItemList.findIndex((item) => {
              return item.name == 'member'
            })
            if (index > -1) {
              let cItem = Object.assign({}, this.collapseItemList[index])
              let objIndex = cItem.filterItems.findIndex((item) => {
                return item.key == 'inclinationNames'
              })
              if (objIndex > -1) {
                cItem.filterItems[objIndex].list = cItem.filterItems[objIndex].list.concat(data)
              }
              this.collapseItemList.splice(index, 1, cItem)
            }
          }else{
            this.$toast('请求异常，请稍后重试')
          }
          this.$loading.hide();
        }).catch(() => {
          this.$loading.hide();
          this.$toast('请求失败，请稍后重试')
        });
      },
      /**
       * 格式化数据
       */
      getTransformData(data, defaultValue = '') {
        if (utils.isNullData(data)) {
          return defaultValue
        }
        return data;
      },
      // 搜索
      onSearch() {
        this.$router.push({
          path:'/searchPage',
          query:{
            pageType:'groupMemberList',
            corpId:this.corpId
          }
        })
      },
      // 下拉刷新
      onRefresh() {
        // 清空列表数据
        this.refreshing = true
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.error = false;
        this.page = 1
        this.total = 0
        this.onLoad();
      },
      // 列表加载数据
      onLoad() {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        if (this.list.length > 0 && this.list.length >= this.total) {
          this.finished = true
          return
        }
        this.getDataList()
      },
      getDataList() {
        this.$loading.hide()
        this.loading = true
        let params = Object.assign({},this.queryData)
        // if(!utils.isNullData(this.searchInfoName)){
        //   params.name = this.searchInfoName
        // }
        if(!utils.isNullData(params.searchInfo)){
          params.userIds = params.searchInfo.split(',')
          delete params.searchInfo
        }
        if(!utils.isNullData(params.startTime)){
          params.startTime = moment(params.startTime).format('YYYY-MM-DD')
        }
        if(!utils.isNullData(params.endTime)){
          params.endTime = moment(params.endTime).format('YYYY-MM-DD')
        }
        http({
          url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getBsEnterpriseWechatUserKanban",
          method: "post",
          parmes: {
            ...params,
            corpId:this.corpId,
            pageIndex:this.page,
            pageSize:this.pageSize
          }
        }).then(rps => {
          if (rps.code == 200) {
            let data = rps.data;
            this.statisticInfo = data
            if(data.bsEnterpriseWeChatUserKanbanListVos && data.bsEnterpriseWeChatUserKanbanListVos.length > 0){
              data.bsEnterpriseWeChatUserKanbanListVos.forEach((item) => {
                if(!utils.isNullData(item.inclinationVal)){
                  item.inclinationVal = Number(Number(item.inclinationVal) * 100)
                }
              })
              this.list = this.list.concat(data.bsEnterpriseWeChatUserKanbanListVos);
              this.page++
            }
            this.total = data.total ? data.total : this.list.length
            this.loading = false;
            if (this.list.length >= this.total) {
              this.finished = true;
            }
          }else{
            this.loading = false;
            this.error = true;
            this.$toast('请求异常，请稍后重试')
          }
          this.$loading.hide();
        }).catch((err) => {
          console.error(err)
          this.$loading.hide();
          this.loading = false;
          this.error = true
          this.$toast('请求失败，请稍后重试')
        });
      },
      // 清空筛选项
      handleClear(){
        this.searchInfoName = ''
        this.queryData.searchInfo = ''
        this.onRefresh()
      },
      // 点击筛选
      handleFilter() {
        this.showFilter = true
      },
      // 关闭筛选框
      handleClose() {
        this.showFilter = false
      },
      // 筛选确认
      handleConfirm(selectItemIds,selectItems,customeTime) {
        this.showFilter = false
        // let queryData = Object.assign({},selectItemIds)
        let queryData = JSON.parse(JSON.stringify(selectItemIds))
        for(let key in queryData){
          let val = queryData[key]
          if(val instanceof Array){
            let index = val.indexOf('-1')
            if(index > -1){
              queryData[key].splice(index,1)
            }
          }else{
            if(val == '-1'){
              queryData[key] = ''
            }
          }
        }
        this.filterItemIds = selectItemIds
        this.filterItems = selectItems
        if(!utils.isNullData(customeTime)){
          this.customeTime = customeTime
          let startTime = moment(customeTime.split('-')[0]).format('YYYY-MM-DD')
          let endTime = moment(customeTime.split('-')[1]).format('YYYY-MM-DD')
          queryData.startTime = startTime
          queryData.endTime = endTime
        }else{
          if(selectItems.timeType && !utils.isNullData(selectItems.timeType.value)){
            let startTime = moment(selectItems.timeType.value.split('-')[0]).format('YYYY-MM-DD')
            let endTime = moment(selectItems.timeType.value.split('-')[1]).format('YYYY-MM-DD')
            queryData.startTime = startTime
            queryData.endTime = endTime
          }
        }
        this.queryData = Object.assign({},this.queryData,queryData)
        this.onRefresh()
      },
      // 查看详情
      handleDetail(item){
        this.$router.push({
          path:'/groupMemberStatisticDetail',
          query:{
            id:item.id,
            memberId:item.memberId,
            wxUserId:item.wxUserId,
            corpId:this.corpId
          }
        })
      },
      // 查看tip提示内容
      handleTip(item){
        this.currentTipItem = item
        this.showTip = true
      },
      handleTipClose(){
        this.showTip = false
        this.currentTipItem = {}
      }
    }
  })
  </script>
  <style lang="less" scoped>
  @import url("../style/index.css");
  
  .topView {
    padding: 16px 24px;
    background: #ffffff;
  
    //.searchView {
    //  width: 90%;
    //  padding: 0 0 !important;
    //
    //  .van-search__content {
    //    padding-left: 16px;
    //    height: 64px;
    //    display: flex;
    //    align-items: center;
    //  }
    //}
    .searchView{
      display: flex;
      align-items: center;
      width: calc(90% - 32px);
      padding: 8px 16px;
      height: 64px;
      background: #F6F6F6;
      border-radius: 32px;
      margin-left: 4px;
      font-size: 28px;
      font-weight: 400;
      color: #898887;
      line-height: 40px;
      .searchContentView{
        width: calc(100% - 48px);
        display: flex;
        align-items: center;

        .searchInfoView{
          font-size: 28px;
          font-weight: 400;
          color: #898887;
          line-height: 40px;
          width: calc(100% - 52px);
        }
      }
    }
  }
  
  .statisticView {
    background: rgba(68, 102, 245, 0.06);
    border-radius: 12px;
    padding: 24px 16px;
    margin-top: 16px;
  
    .title {
      font-size: 28px;
      font-weight: 500;
      color: #30417A;
      line-height: 40px;
      //margin-bottom: 24px;
    }
    .timeItem{
      background: #FFFAE6;
      border-radius: 0px 18px 18px 18px;
      padding: 4px 12px;
      font-size: 22px;
      font-weight: 400;
      color: #F08E3C;
      line-height: 28px;
      display: flex;
      align-items: center;
      margin-left: 24px;
    }
    .statisticItem {
      width: 25%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
  
      .titleView {
        font-size: 36px;
        font-weight: bold;
        color: #3B3A38;
        line-height: 42px;
        margin-bottom: 10px;
      }
  
      .infoView {
        font-size: 24px;
        font-weight: 400;
        color: #8C94A0;
        line-height: 33px;
      }
  
      .line-1e1 {
        position: relative;
        width: 1px;
        height: 31px;
  
        &::after {
          position: absolute;
          top: 0;
          left: 0;
          content: ' ';
          width: 200%;
          height: 200%;
          background: #E1E1E1;
          transform-origin: 0 0;
          transform: scale(0.5);
        }
      }
    }
  }
  
  .sectionTitle {
    padding: 24px 16px 16px 16px;
    font-size: 28px;
    font-weight: 500;
    color: #3B3A38;
    line-height: 40px;
  }
  
  .listView {
    padding: 0 16px;

    .listItem {
      background: #ffffff;
      padding: 24px 20px 24px 24px;
      margin-bottom: 16px;
  
      .itemTopView {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
  
        .itemTitleView {
          font-size: 32px;
          font-weight: 500;
          color: #3B3A38;
          line-height: 40px;
          width: 73%;
        }
  
        .rightView {
          display: flex;
          align-items: center;
          justify-content: flex-end;
  
          .btn {
            font-size: 24px;
            font-weight: 400;
            color: #4466F5;
            // line-height: 32px;
          }
        }
      }
  
      .labelView {
        font-size: 28px;
        font-weight: 400;
        color: #8C94A0;
        line-height: 36px;
      }
  
      .nameView {
        font-size: 28px;
        font-weight: 500;
        color: #26282A;
        line-height: 36px;
      }
  
      .tagView {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        width: calc(100% - 120px);
  
        .tagItem {
          flex-shrink: 0;
          background: #4088EE;
          border-radius: 4px;
          padding: 0 6px;
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 26px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
  
      .chartView {
        width: 120px;
        height: 120px;
      }
    }
  }
  
  .van-search .van-cell {
    display: flex;
    align-items: center;
    padding: 0 0;
  }
  
  /deep/ .van-search__content--round {
    border-radius: 32px;
  
    .van-field__left-icon {
      display: flex !important;
      align-items: center !important;
      margin-right: 4px !important;
    }
  }
  
  .van-search__content {
    background: #F6F6F6 !important;
  }
  </style>
  